import { useEffect, useState } from "react";
import { toast } from "react-toastify";

import { spamCheck, webrtcCheck } from "@forproxyband/react-tools";

import { useClientData } from "../../store/client/client.selectors";

import { useWebRtcStatus } from "../useWebRtcStatus";

export const useAnonymityInfo = (setShowLoader, t) => {
  const { anonymityInfo } = useClientData();

  const [ips, setIps] = useState([]);
  const [blackList, setBlackList] = useState(null);
  const errorMessage = () => toast.error(t("global.error"));
  const setterSpamResultCallback = res => {
    setBlackList(res);
  };

  const webRtcStatus = useWebRtcStatus(ips, anonymityInfo?.ip, setIps);
  useEffect(() => {
    (async () => {
      if (anonymityInfo?.ip) {
        if (!blackList) {
          await spamCheck.check(
            anonymityInfo?.ip,
            setterSpamResultCallback,
            errorMessage,
            () => {},
          );
        }
        if (!ips.length) {
          webrtcCheck.check(setIps);
        }
      }
    })();
  }, [anonymityInfo, blackList]);

  return { anonymityInfo, blackList, webRtcStatus, ips };
};
